import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home-page.vue';
import Profile from '../views/profile.vue';
import Styleguide from '../views/styleguide.vue';
import Board from '../views/board-page.vue';
import Help from '../views/help.vue';
import ProfileBilling from '../views/profile-billing.vue';
import ProfileWorkspace from '../views/profile-workspace.vue';
import Brands from '../views/brands-page';
import BrandsSlug from '../views/brands-slug-page';
import BrandsSlugAdList from '../views/brands-slug-ad-list';
import Multiplayer from '../views/multiplayer-page';
import MultiplayerLandingPages from '../views/multiplayer-landing-pages.vue';
import Uploads from '../views/uploads';
import Share from '../views/share';
import Generations from '../views/generations';
import McpPage from '../views/mcp-page.vue';
import McpAuthorizePage from '../views/mcp-authorize-page.vue';
import AdminPage from '../views/admin-page.vue';
import TagManagerPage from '../views/tag-manager-page.vue';

import Page404 from '../views/page404';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/profile',
		name: 'Profile',
		component: Profile,
		children: [
			{
				path: 'billing',
				name: 'Billing Portal',
				component: ProfileBilling,
			},
			{
				path: 'workspace',
				name: 'Workspace Settings',
				component: ProfileWorkspace,
			},
		],
	},
	{
		path: '/brands',
		name: 'Brands',
		component: Brands,
	},
	{
		path: '/brands/:slug',
		name: 'BrandsSlug',
		component: BrandsSlug,
		children: [
			{
				path: 'ads',
				name: 'Ads',
				component: BrandsSlugAdList,
			},
			{
				path: 'landing-pages',
				name: 'LandingPages',
				component: ProfileWorkspace,
			},
		],
	},
	{
		path: '/multiplayer',
		name: 'Multiplayer',
		component: Multiplayer,
		children: [
			{
				path: 'landing-pages',
				name: 'Landing pages',
				component: MultiplayerLandingPages,
			},
			{
				path: 'workspace',
				name: 'Workspace Settings',
				component: ProfileWorkspace,
			},
		],
	},
	{
		path: '/uploads',
		name: 'Uploads',
		component: Uploads,
	},
	{
		path: '/renderer',
		name: 'Renderer preview',
		component: () => import('../views/renderer-page.vue'),
	},
	{
		path: '/styleguide',
		name: 'Styleguide',
		component: Styleguide,
	},
	{
		path: '/boards/:slug',
		name: 'Board',
		component: Board,
	},
	{
		path: '/share/:slug',
		name: 'Share',
		component: Share,
	},
	{
		path: '/help',
		name: 'Help',
		component: Help,
	},
	{
		path: '/generations',
		name: 'Generations',
		component: Generations,
	},
	{
		path: '/mcp',
		name: 'MCP Server',
		component: McpPage,
	},
	{
		path: '/tags',
		name: 'Tag manager',
		component: TagManagerPage,
	},
	{
		path: '/mcp/authorize',
		name: 'Connect to Swipekit',
		component: McpAuthorizePage,
	},
	{
		path: '/admin',
		name: 'Admin',
		component: AdminPage,
	},
	{
		path: '/admin/stats',
		name: 'Admin Stats',
		component: () => import('../views/admin-stats-page.vue'),
	},
	{
		path: '/admin/emails',
		name: 'Admin Email Outreach',
		component: () => import('../views/admin-email-stats-page.vue'),
	},
	{
		path: '/admin/api-access',
		name: 'Admin API Access',
		component: () => import('../views/admin-api-access-page.vue'),
	},

	// 404 page
	{
		path: '*',
		name: 'page404',
		component: Page404,
	},
];

const router = new VueRouter({
	mode: 'history',
	routes,
});

export default router;
